import { type ChangeEventHandler, type FC } from 'react';
import { TextInput, type TextInputProps } from '@mantine/core';
import { formatCardNumberInput, normalizeCardNumberInput } from '../../lib/formatters/formatCardNumber';

export interface CardInputProps extends Omit<TextInputProps, 'defaultValue' | 'onChange' | 'type' | 'value'> {
    value?: string | null;
    onChange?: (value: string) => void;
}

export const CardInput: FC<CardInputProps> = ({
    autoComplete = 'cc-number',
    inputMode = 'numeric',
    onChange,
    placeholder = '0000 0000 0000 0000',
    value,
    ...props
}) => {
    const handleChange: ChangeEventHandler<HTMLInputElement> = ({ currentTarget: { value } }) => {
        onChange?.(normalizeCardNumberInput(value));
    };

    return (
        <TextInput
            {...props}
            autoComplete={autoComplete}
            inputMode={inputMode}
            onChange={handleChange}
            placeholder={placeholder}
            value={formatCardNumberInput(value ?? '')}
        />
    );
};
